export default __webpack_public_path__ + "static/media/horizontal.f232e8af.svg";